import React, { useCallback, useEffect, useState } from 'react';
import Dialog from './Dialog';
import { usePOWebofficeSDKState } from '../../context/poWebOfficeSDKContext';
import styled from 'styled-components';
import { downloadFileWithBlob, getFileNameOnly } from '../../utils/FileControlUtil';
import { closeDialog } from '../../store/modules/dialog';
import { useDispatch } from 'react-redux';
import { EDIT_FROM } from '../../define/global';
import IconSpinner from '../../img/spinner.gif';
import IconCheck from '../../img/check.gif';
import ga from '../../utils/gaConnect';
import { useTranslation } from 'react-i18next';
import FixedAD, { FIXED_AD_ID } from '../common/FixedAD';
import { useAppDataSliceSelector } from '../../store/modules/appData';
import { isDevicePC } from '../../utils/util';
import { useDocInfoSliceSelector } from '../../store/modules/docInfo';
import DocumentDownloadDialogMobile from './mobile/DocumentDownloadDialogMobile';
import { useRef } from 'react';

const DialogBody = styled.div`
  display: flex;
  width: 332px;
  height: 398px;
  flex-flow: column;
  justify-content: center;
  align-items: center;
`;

export const DownloadStateIcon = styled.img`
  width: 64px;
  height: 64px;
`;

const DownloadComment = styled.p`
  font-size: 14px;
  font-weight: 400;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #2f3133;
  margin: 11px 0 32px 0;
`;

function DocumentDownloadDialog({ from, isShow }) {
  const { t } = useTranslation();
  const poSDKContextState = usePOWebofficeSDKState();
  const [isComplete, setIsComplete] = useState(false);
  const appDataSlice = useAppDataSliceSelector();
  const docInfoSlice = useDocInfoSliceSelector();
  const isPCView = isDevicePC(appDataSlice.deviceType);

  const closeDispatch = useDispatch();
  const onClickCloseBtn = () => {
    closeDispatch(closeDialog());
  };

  const sendDownloadGAData = useCallback(
    (executeTime) => {
      let label = null;
      switch (from) {
        case EDIT_FROM.FROM_HEADER:
          label = isPCView ? '헤더' : '공유뷰';
          break;
        case EDIT_FROM.FROM_FILEMENU:
          label = '파일탭';
          break;
        case EDIT_FROM.FROM_NOTIFICATION:
          label = '알림';
          break;
        default:
          break;
      }

      if (label) {
        ga.event({
          category: '문서 다운로드',
          action: '다운로드',
          label,
          value: executeTime
        });
      }
    },
    [from]
  );

  const savedFile = useRef({ name: '', blob: null });
  useEffect(() => {
    if (isComplete == true) downloadFileWithBlob(savedFile.current.name, savedFile.current.blob);
  }, [isComplete]);

  const downloadDocument = useCallback(() => {
    const poSDKReady = poSDKContextState.poInstance !== null;
    if (poSDKReady) {
      const start = new Date();
      poSDKContextState.poInstance.handle
        .saveDocument()
        .then((arg) => {
          savedFile.current = { name: docInfoSlice.fileName, blob: arg.blob };
          setIsComplete(true);
          sendDownloadGAData(new Date() - start);
        })
        .catch((err) => {
          alert(err.message);
        });
    }
  }, [poSDKContextState, sendDownloadGAData]);

  useEffect(() => {
    setTimeout(() => {
      downloadDocument();
    }, 3000);
  }, [downloadDocument]);

  return (
    <>
      {isPCView === true ? (
        <Dialog
          title=""
          showCloseBtn={isComplete}
          showTitleSeperateLine={false}
          onClickCloseBtn={onClickCloseBtn}
          isShow={isShow}>
          <DialogBody>
            {isComplete ? (
              <>
                <DownloadStateIcon src={IconCheck} />
                <DownloadComment>{t('DocumentDownloadDialog.DownloadSuccess')}</DownloadComment>
              </>
            ) : (
              <>
                <DownloadStateIcon src={IconSpinner} />
                <DownloadComment>{t('DocumentDownloadDialog.DownloadReady')}</DownloadComment>
              </>
            )}
            <FixedAD id={FIXED_AD_ID.IN_DOWNLOAD_DOCUMENT} />
          </DialogBody>
        </Dialog>
      ) : (
        <DocumentDownloadDialogMobile
          isComplete={isComplete}
          onClickCloseBtn={onClickCloseBtn}
          isShow={isShow}
        />
      )}
    </>
  );
}

export default DocumentDownloadDialog;
